import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { MASTER_PRODUCTS } from 'constants/merchandising';
import Theme from 'styles/theme';
import Money from 'utils/Money';
import Settings from 'utils/Settings';

import { SHOP_SPECIFIC_AFTERPAY_SETTINGS } from './constants';

class Afterpay extends React.PureComponent {
  static propTypes = {
    price: PropTypes.number.isRequired,
    masterId: PropTypes.string.isRequired,
  };

  static get selector() {
    return 'pdp-afterpay';
  }

  static get locale() {
    return `${Settings.currentLocale}`.replace('-', '_'); // must be en_US vs. en-US per Afterpay team
  }

  static get minimumPriceThreshold() {
    return get(
      SHOP_SPECIFIC_AFTERPAY_SETTINGS,
      [Settings.shopID, 'minimumPriceThreshold'],
      get(SHOP_SPECIFIC_AFTERPAY_SETTINGS, ['default', 'minimumPriceThreshold'])
    );
  }

  static get maximumPriceThreshold() {
    return get(
      SHOP_SPECIFIC_AFTERPAY_SETTINGS,
      [Settings.shopID, 'maximumPriceThreshold'],
      get(SHOP_SPECIFIC_AFTERPAY_SETTINGS, ['default', 'maximumPriceThreshold'])
    );
  }

  static get modalContent() {
    return get(
      SHOP_SPECIFIC_AFTERPAY_SETTINGS,
      [Settings.shopID, 'modalContent'],
      get(SHOP_SPECIFIC_AFTERPAY_SETTINGS, ['default', 'modalContent'])
    );
  }

  componentDidMount() {
    if (this.hasValidProduct && this.hasValidPrice) {
      this.fetchAfterpayScript();
    }
  }

  get hasValidProduct() {
    const { masterId } = this.props;

    return (
      masterId !== MASTER_PRODUCTS.DIGITAL_GIFT_CARD &&
      masterId !== MASTER_PRODUCTS.PHYSICAL_GIFT_CARD &&
      masterId !== MASTER_PRODUCTS.PHYSICAL_GIFT_CARD_BOOKLET
    );
  }

  get hasValidPrice() {
    const { price } = this.props;

    return price >= Afterpay.minimumPriceThreshold && price <= Afterpay.maximumPriceThreshold;
  }

  get widgetOptions() {
    const { price } = this.props;

    return {
      priceSelector: `#${Afterpay.selector}`, // will mount an adjacent *sibling* node
      amount: price,
      locale: Afterpay.locale,
      currency: Settings.currency,
      minMaxThreshold: {
        min: Afterpay.minimumPriceThreshold,
        max: Afterpay.maximumPriceThreshold,
      },
      afterpayLogoColor: 'black',
      modalContent: Afterpay.modalContent,
    };
  }

  get getDecimalFormat() {
    const { price } = this.props;

    return new Money(price).getDecimalFormat();
  }

  fetchAfterpayScript() {
    const $script = document.createElement('script');

    $script.id = 'afterpay-widget';
    $script.type = 'text/javascript';
    $script.async = true;
    $script.src = 'https://js.afterpay.com/afterpay-1.x.js';
    document.head.appendChild($script);
  }

  render() {
    return (
      this.hasValidProduct && (
        <div id={Afterpay.selector}>
          <afterpay-placement
            data-locale={Afterpay.locale}
            data-currency={Settings.currency}
            data-amount={this.getDecimalFormat}
            data-modal-theme="white"
            data-badge-theme="white-on-black"
            data-logo-type="lockup"
            data-size="xs"
          />
          <style jsx global>
            {`
              afterpay-placement {
                --logo-badge-width: 66.66px;
                line-height: 1.5;
                margin: ${Theme.get('spacing')}px 0 0 0;
                letter-spacing: 0.3px;
              }
            `}
          </style>
        </div>
      )
    );
  }
}

export default Afterpay;
